<template>
  <div class="sub-com-wrap">

    <header class="header-wrap">
      <div class="icon">
        <el-icon color="#FFFFFF" size="40">
          <User/>
        </el-icon>
      </div>
      <h5>{{ personInfo.ticName }}</h5>
    </header>

    <div class="block">
      <div class="title">
        <div class="sep"></div>
        基本信息
      </div>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">姓名</el-col>
        <el-col :span="6" class="info-label">{{ personInfo.ticName }}</el-col>
        <el-col :span="5" class="info-label right">电子邮箱</el-col>
        <el-col :span="5" class="info-label">待补充</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">手机号码</el-col>
        <el-col :span="6" class="info-label">xxxxxx</el-col>
        <el-col :span="5" class="info-label right">地址</el-col>
        <el-col :span="5" class="info-label">xxxxxx</el-col>
      </el-row>
    </div>

    <div class="block">
      <div class="title">
        <div class="sep"></div>
        证件信息
      </div>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">证件类型</el-col>
        <el-col :span="6" class="info-label">{{ '居民身份证' }}</el-col>
        <el-col :span="5" class="info-label right">证件有效期起</el-col>
        <el-col :span="5" class="info-label">xxxxxx</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">证件号码</el-col>
        <el-col :span="6" class="info-label">{{ personInfo.idNumber }}</el-col>
        <el-col :span="5" class="info-label right">证件有效期止</el-col>
        <el-col :span="5" class="info-label">xxxxxx</el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
const personInfo = ref({
  ticName: '王云霞',
  idNumber: 'xx',
})
</script>

<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;

  .header-wrap {
    display: flex;
    align-items: center;
    padding: 20px;
    background: #FFFFFF;

    .icon {
      width: 60px;
      height: 60px;
      background-color: #409eff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > h5 {
      font-size: 20px;
      font-weight: 600;
      margin-left: 10px;
    }
  }

  .block {
    margin-top: 20px;
    background-color: #FFFFFF;
    padding: 20px 0;

    .title {
      font-size: 20px;
      line-height: 30px;
      color: #303133;
      font-weight: 700;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;
      padding: 0 20px 20px 20px;
      margin-bottom: 20px;

      .sep {
        width: 5px;
        background-color: #409eff;
        margin-right: 8px;
        height: 20px;
        border-radius: 20%;
      }
    }

    .info-row {
      margin: 0 20px !important;
      border-bottom: 1px solid #ebeef5;

      .info-label {
        line-height: 50px;

        &.right {
          text-align: right;
        }
      }
    }


  }

}
</style>
